import router from '@/router'
import { signOut } from 'firebase/auth'
import { auth } from '../views/firebase.js'
import { createStore } from 'vuex'
import { collection, getDocs, orderBy, query} from "firebase/firestore";
import { db } from "../views/firebase.js";

export default createStore({
  state: {
    authUser: '',
    main_menu: [
      { name: 'معرض الصور', link: '/gallary', icon: 'mdi-image' },
      { name: '  عن الريزن', link: '/about', icon: 'mdi-bird' },
      { name: 'الرئيسيه', link: '/', icon: 'mdi-home' },
    ],
    admin_menu: [
      { name: 'تعديل فيديو ', link: '/admin/updateVideo', icon: 'mdi-video-switch' },
      { name: ' إنشاء فيديو', link: '/admin/createNewVideo', icon: 'mdi-video-box' },
      { name: 'عرض جميع المستخدمي', link: '/admin/SelectAllUsers', icon: 'mdi-select-all' },
      { name: 'إنشاء مستخدم جديد', link: '/admin/createNewUser', icon: 'mdi-pencil' },

    ],
    social_media: [
      {
        icon: 'mdi-whatsapp',
        name: "whatsapp",
        link:
          "//api.whatsapp.com/send?phone=4388774430&text=من فضلك أريد المساعدة- هل أنت متاح الأن ؟",
        fun: true

      },
      {
        icon: 'mdi-instagram',
        name: "instagram",
        link: "https://www.instagram.com/october.arts96/profilecard/?igsh=MXQwa2R2YjFybXFzMQ%3D%3D",

      },
      {
        icon: 'mdi-alpha-t-circle-outline',
        name: "youtube",
        link: "https://www.tiktok.com/@october_arts?_t=8rJpdVkOcfo&_r=1",

      },
    ],
    videoStore: [{
      title: '',
      subText: '',
      url: '',
      createAt: ''
    }],
    urlUrl: '',
    user: {
      email: ''
    },
    currentVideo: {
      title: '',
      subText: '',
      videoLink: ''
    },
    adminData: {
      adminUserName: '',
      adminPassword: ''
    }

  },
  getters: {
    user(state) {
      return state.user
    },
    videoStore(state) {

      return state.videoStore.sort((a,b)=>a.createAt-b.createAt)
    },
    currentVideo(state) {
      return state.videoStore
    },
    adminData(state) {
      return state.adminData
    }

  },
  mutations: {

    set_user(state, data) {
      state.user = data
    },
    set_video(state, data) {
      state.videoStore.push(data)
    },
    set_Current_video(state, passVideo) {
      state.currentVideo.title = passVideo.title
      state.currentVideo.subText = passVideo.subText
      state.currentVideo.videoLink = passVideo.videoLink
    },
    xxx(state, data) {
      state.adminData.adminUserName = data.adminUsername
      state.adminData.adminPassword = data.adminPassword
    }

  },
  actions: {
    async getTheData(context, user) {
      if (user) {
        context.commit("set_user", { email: user.email })
       // router.push('tutorial')
      }
      else {
        context.commit("set_user", null);
        router.push('/')
      }
    },
    async logOut(context) {
      await signOut(auth)
      context.commit('set_user', null)
    },
    async getAllVideos(context) {
      this.state.videoStore=[]
      const unOrderVideos= collection(db,"VideosDetails")
      const q=query(unOrderVideos,orderBy("createdAt","asc"))

      const querySnapshot = await getDocs(q);
      
      querySnapshot.forEach((doc) => {
        context.commit("set_video", doc.data())

      });
      console.log(' get all videos' )
    },
     getAdminData(context, adminData) {
      if (adminData.adminUsername == 'fatima' && adminData.adminPassword == '123456') {
        console.log(adminData.adminPassword)
        context.commit("xxx", adminData)
      }
  

    }




  },

})
